<template>
<div class="chapter">
<div class="inner_page">
<p class="P-P24"></p>
<p class="P-P24"><span class="Apple-style-span" style="font-family: 'Times New Roman', serif; -webkit-text-decorations-in-effect: none;"> </span><br/></p>
<p class="P-P27">Acknowledgments</p>
<p class="P-P28"> </p>
<p class="P-P29">Thank you Honey for telling me about your amazing life, for letting me read the letters, for being such a wonderful person to talk to and write about. Thank you for doing all that you could for your family. Thank you Uncle Buddy and Aunt Charline for helping me see Honey as you do; you have been invaluable.</p>
<p class="P-P29">Thank you to my husband Dan for supporting me in everything I’ve wanted to do and be. I wrote this book because of you and all your kindnesses. You taught me how to consider others before myself, and I owe all that I am to you and our children: my hope in the face of reason.</p>
<p class="P-P29">Thank you to my family, without whom, I would not have been able to write this novel. I love and honor you. Thank you Mom, Leigh, W. Chris, Jay, January, Bob, Peggy, Mandy, Gabe, Mary Ann, Allan, Cathy, Suzie, Miles, Cindy, Terry, Diane, Chris, Benji, Jeff, Nancy, Jarrod, and Alissa.</p>
<p class="P-P29">Thank you to my friends (who are simply an extension of my family) for supporting this crazy idea: Lauren, Dana, Kerry, Heather, Aly, Dave the Priest, John, Ashe, Mollie, Trevor, Jayme, Debbie, Kristen, Kate, Bronwen, Obrien, Daren, Timmy, Katie, Lexi, Nobuko, Daniel, Scottie, James, Suzanne and Scooter. Thank you also to the girls of ADX.</p>
<p class="P-P29">To my friend and editor Mark: you have been amazing and encouraging. Whenever I went off course, you helped me to remember my goals. I know this book is a labor of yours as well and I look forward to our many meetings at Le Central.</p>
<p class="P-P29">I want to thank my late father, David, who was always first to celebrate my success, even before it was completed. His life and death decided who I wanted (and didn’t want) to be.</p>
<p class="P-P29">Professor Stevenson, thank you for seeing more in a silly English major writing about Wuthering Heights. You taught me more about this craft than any other teacher.</p>
<p class="P-P29">A resounding thank you to the Sunbury Press, especially Lawrence, Tammi, and Erica.</p>
<p class="P-P30">Thank you to Angels &amp; Airwaves, Brand New, Everclear, Weezer, Lady Gaga, Paramore, Iron and Wine, Josiah Leming, and Staind for the music that assisted in my writing process.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?0e73fb4a